module.exports = __webpack_public_path__ + "img/applications-open.59591d5d.svg";